import React from 'react'
import ContextWrapper from './ContextWrapper'
import store from '../../store';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';

interface Props {
    children: React.ReactNode;
}

const GlobalStatesWrapper: React.FC<Props> = (props) => {
    const persistor = persistStore(store);

    return (
        <>
            <Provider store={store}>
                <PersistGate loading={null} persistor={persistor}>
                    <ContextWrapper>
                        {props.children}
                    </ContextWrapper>
                </PersistGate>
            </Provider>
        </>
    )
}

export default GlobalStatesWrapper